import { render, staticRenderFns } from "./SystemNotifications.vue?vue&type=template&id=0f2aa551&scoped=true&"
import script from "./SystemNotifications.vue?vue&type=script&lang=js&"
export * from "./SystemNotifications.vue?vue&type=script&lang=js&"
import style0 from "./SystemNotifications.vue?vue&type=style&index=0&id=0f2aa551&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2aa551",
  null
  
)

export default component.exports